import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/transactions/page.tsx");
